import React from 'react';
import { FormattedMessage } from 'react-intl';
import './ErrorModal.scss';
import { isProd, isStage } from '../../../constants/config';
import { Button } from '@repo/apg-ui';
import Card from '../../Card';
import { ReactComponent as RedxIcon } from '../../../assets/icons/redX.svg';
import { ReactComponent as UndoIcon } from '../../../assets/icons/errorUndoIcon.svg';
import { ReactComponent as SpeechIcon } from '../../../assets/icons/errorSpeechIcon.svg';
import { ReactComponent as UserIcon } from '../../../assets/icons/errorUserIcon.svg';
import { useNavigate } from 'react-router';

interface Props {
  intl: any;
  location: any;
  onClose?: any;
  errors?: any;
  userDataEC?: any;
}

const ErrorModal = (props: Props) => {
  const navigate = useNavigate();

  const getLink = () => {
    const { intl } = props;

    const linksProd = {
      start: intl.formatMessage({
        id: 'ec.dashboardService.boxBookingProdLink',
        defaultMessage: 'https://apgsga.ch/de/aussenwerbung/plakate-online-buchen/',
      }),
    };

    const linksStage = {
      start: intl.formatMessage({
        id: 'ec.dashboardService.boxBookingStageLink',
        defaultMessage:
          'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/aussenwerbung/plakate-online-buchen/',
      }),
    };

    const linksDev = {
      start: intl.formatMessage({
        id: 'ec.dashboardService.boxBookingDevLink',
        defaultMessage:
          'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/aussenwerbung/plakate-online-buchen/',
      }),
    };

    return isProd ? linksProd : isStage ? linksStage : linksDev;
  };

  return (
    <div className='error-container-modal' id='root'>
      <div className='close-modal'>
        <Button
          onClick={() => {
            props.onClose
              ? props.onClose()
              : navigate({
                  search: '',
                });
          }}
        >
          <FormattedMessage id='ec.confirmation.close' defaultMessage='Schliessen' />
          <RedxIcon />
        </Button>
      </div>

      <p className='fw-bold big-title'>
        <FormattedMessage id='ec.modal.error.errorTitle' defaultMessage='Entschuldigung, etwas ist schief gelaufen.' />
      </p>

      <p className='normal-text col-9 ps-0'>
        {props.errors && Object.keys(props.errors).length > 0
          ? props.errors[Object.keys(props.errors)[0]]['message']
          : null}
      </p>

      <div className='row'>
        <div className='col-4'>
          <Card
            to={props.location.search.split('error=true')[0]}
            icon={<UndoIcon />}
            title={props.intl.formatMessage({
              id: 'ec.modal.error.tryAgain',
              defaultMessage: 'Erneut versuchen',
            })}
            text={props.intl.formatMessage(
              {
                id: 'ec.modal.error.explanation1',
                defaultMessage:
                  'Es tut uns leid, aber es scheint ein Problem aufgetreten zu sein.{br}{br}Versuchen Sie es nochmals oder kontaktieren Sie uns.',
              },
              { br: <br /> },
            )}
          />
        </div>

        <div className='col-4'>
          <Card
            hideArrow
            icon={<SpeechIcon />}
            title={props.intl.formatMessage({
              id: 'ec.modal.error.contactUs',
              defaultMessage: 'Kontakt',
            })}
            text={props.intl.formatMessage(
              {
                id: 'ec.modal.error.explanation2',
                defaultMessage:
                  'Bei Fragen kontaktieren Sie bitte unsere Beraterinnen und Berater unter: \n <tel>+41 58 220 77 77</tel> <mail>servicedesk@apgsga.ch</mail> ',
              },
              {
                tel: (child) => (
                  <a className='d-block' href={`tel:${child}`}>
                    {child}
                  </a>
                ),
                mail: (child) => (
                  <a className='d-block' href={`mailto:${child}`}>
                    {child}
                  </a>
                ),
                chat: (child) => (
                  <a className='d-block' href='#aio-launcher-container'>
                    {child}
                  </a>
                ),
              },
            )}
          />
        </div>

        <div className='col-4'>
          {!!props.userDataEC?.basketInfo ? (
            <Card
              hideArrow
              icon={<UserIcon />}
              title={props.intl.formatMessage({
                id: 'ec.modal.error.customerSupport',
                defaultMessage: 'ServiceDesk',
              })}
              text={props.intl.formatMessage(
                {
                  id: 'ec.modal.error.contactText',
                  defaultMessage:
                    'Gerne helfen wir Ihnen weiter. Teilen Sie uns bitte die untenstehende Warenkorbnummer via Telefon oder E-Mail: {code}',
                },
                {
                  code: <span className={'red-code'}>{props.userDataEC.basketInfo?.basket}</span>,
                },
              )}
            />
          ) : (
            <Card
              hideArrow
              to={getLink().start}
              icon={<UndoIcon />}
              title={props.intl.formatMessage({
                id: 'ec.modal.error.restart',
                defaultMessage: 'Restart',
              })}
              text={props.intl.formatMessage({
                id: 'ec.modal.error.restartText',
                defaultMessage: 'We cannot retrieve your information. Click here to start the process again.',
              })}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
